import React from "react";
import { CATEGORIES } from "@/data/business";
import { ArrowUpRight } from "lucide-react";

export default function Categories() {
  return (
    <section id="categories" className="bg-white py-16 md:py-24" data-testid="categories-section">
      <div className="container-b">
        <div className="mb-10 max-w-2xl">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-blue-700">Product Categories</div>
          <h2 className="font-heading mt-3 text-3xl font-bold tracking-tight text-slate-900 sm:text-4xl lg:text-5xl">
            Everything for your home under one roof
          </h2>
          <p className="mt-3 text-base text-slate-600">
            From large appliances to furniture and mobile accessories — explore the full range available
            in-store at Fatehpur.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {CATEGORIES.map((c) => (
            <a
              key={c.key}
              href="#contact"
              className="category-card lift group relative overflow-hidden rounded-2xl border border-slate-200 bg-white"
              data-testid={`category-card-${c.key}`}
            >
              <div className="relative aspect-[4/3] overflow-hidden bg-slate-100">
                <img src={c.image} alt={c.title} className="h-full w-full object-cover" />
                <div className="absolute inset-0 bg-gradient-to-t from-slate-900/60 via-transparent to-transparent" />
                <span className="absolute right-3 top-3 inline-flex h-9 w-9 items-center justify-center rounded-full bg-white/90 text-slate-900 opacity-0 shadow-md transition-opacity duration-300 group-hover:opacity-100">
                  <ArrowUpRight className="h-4 w-4" />
                </span>
              </div>
              <div className="p-4">
                <div className="font-heading text-lg font-bold text-slate-900">{c.title}</div>
                <div className="mt-1 text-sm text-slate-500">{c.blurb}</div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}
